import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsBuildingContact from 'graphql/fields/FieldsBuildingContact'

const fields = {
	'guid': 'String',
	'building_guid': 'String',
	'name': 'String',
	'email': 'String',
	'active': 'String',
};

export default gql(`
	mutation building_contact( ${ HelperGraphql.createFields( fields ) } ) {
	    building_contact( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsBuildingContact}
	       
	       language {
	            guid
	       }
	    }
	}
`);

